










































































import { defineComponent, computed, ComponentInternalInstance, getCurrentInstance } from '@vue/composition-api';
import { PreviewHandler } from '@/renderer/views/preview/compositions/previewHandler';
import { QueryFrom } from '@/renderer/views/preview/compositions/previewHandlerInterface';
import baseHeadbarHandler from '../composition/baseHeadbarHandler';
export default defineComponent({
  props: {
    /**
     * 当前空间是否超限
     */
    quotaLimited: {
      type: Boolean,
      default: true,
    },
    previewHandler: {
      type: Object as () => PreviewHandler,
      required: true,
    },
  },
  setup(props, context) {
    const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const { previewHandler } = props;
    const { envHelp, goToIndexPage } = baseHeadbarHandler();
    const renderBar = computed(() => {
      const { isInWeMeetApp, isLogined } = vm.$store.getters;
      return {
        homeIcon: !isInWeMeetApp || (isInWeMeetApp && !isLogined),
        envHelp: !!envHelp.value,
        dropdownOperate: previewHandler.queryFrom.value !== QueryFrom.Share,
      };
    });
    const headerHandler = previewHandler.headerActionHandler;
    if (!headerHandler) return {};
    return {
      envHelp,
      renderBar,
      isDocPreview: headerHandler.isDocPreview,
      isDocEdit: headerHandler.isDocEdit,
      isMeidaPreview: headerHandler.isMeidaPreview,
      renderAction: headerHandler.renderAction,
      goToIndexPage,
      onOperateEventProxy: headerHandler.onOperateEventProxy,
    };
  },
});
